import { render, staticRenderFns } from "./LabelNormalText.vue?vue&type=template&id=3061f37e&scoped=true"
import script from "./LabelNormalText.vue?vue&type=script&lang=js"
export * from "./LabelNormalText.vue?vue&type=script&lang=js"
import style0 from "./LabelNormalText.vue?vue&type=style&index=0&id=3061f37e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061f37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3061f37e')) {
      api.createRecord('3061f37e', component.options)
    } else {
      api.reload('3061f37e', component.options)
    }
    module.hot.accept("./LabelNormalText.vue?vue&type=template&id=3061f37e&scoped=true", function () {
      api.rerender('3061f37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/normal/LabelNormalText.vue"
export default component.exports